import { InfoNote } from '@ghp/ui'
import { Info } from 'lucide-react'

/**
 * Ce que disent les champs laissés à « — » : la maquette validée les porte, le modèle pas
 * encore, et la saisie du terrain n'attend pas après eux (décision du 21/08). Il n'en reste que
 * deux, « Maître d'ouvrage » et « Entreprise », dans l'onglet « Infos » de l'éditeur.
 *
 * ⚠️ **Jamais sous un champ que le modèle porte et que le dossier tait.** La pré-fiche
 * d'ouverture et la carte « Coordonnées du bâtiment » la montraient tant que le réseau manquait
 * au modèle ; il descend depuis M43, et leur « — » dit désormais que le dossier se tait.
 * L'annoncer « à venir » ferait attendre à l'agent une donnée que personne n'enverra.
 *
 * ⚠️ **Une fois par carte, jamais sous chaque champ** : répétée six fois, elle pèse plus que
 * les valeurs qu'elle commente. Elle a sa place parce qu'un tiret sans motif pousse l'agent à
 * chercher ce qu'il aurait oublié de remplir.
 */
export function NotYetSynced({ className }: { className?: string }) {
  return (
    <InfoNote className={className} icon={<Info size={15} />}>
      Les champs à « — » ne descendent pas encore du back-office. Ils arriveront sans que la saisie
      du terrain soit à reprendre.
    </InfoNote>
  )
}
